import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import useSEO from "../lib/useSEO";
import { Loader2, ShieldCheck } from "lucide-react";

export default function AdminAuthPage() {
    const [form, setForm] = useState({ email: "", password: "" });
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    useSEO({
        title: "Admin Sign In",
        description: "LocalLawFinder admin sign in.",
        path: "/admin/auth",
        noindex: true,
    });

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setLoading(true);
        try {
            const user = await login(form.email, form.password);
            if (user.role !== "admin") { setErr("This account is not an admin."); return; }
            navigate("/admin/dashboard");
        } catch (e2) {
            setErr(e2?.response?.data?.detail || "Sign in failed");
        } finally { setLoading(false); }
    };

    return (
        <section className="max-w-md mx-auto px-4 sm:px-6 py-16">
            <div className="ll-label mb-3 flex items-center gap-2"><ShieldCheck className="h-3.5 w-3.5" /> Admin Console</div>
            <h1 className="font-serif font-bold text-3xl tracking-tight mb-2" data-testid="admin-auth-title">Admin sign in</h1>
            <p className="text-sm text-muted-foreground mb-8">Restricted access. Authorized personnel only.</p>
            <form onSubmit={submit} className="ll-card space-y-4">
                <div>
                    <label className="ll-label block mb-1.5">Email</label>
                    <input className="ll-input" type="email" required value={form.email}
                           onChange={e => setForm({...form, email: e.target.value})}
                           data-testid="admin-email-input" />
                </div>
                <div>
                    <label className="ll-label block mb-1.5">Password</label>
                    <input className="ll-input" type="password" required value={form.password}
                           onChange={e => setForm({...form, password: e.target.value})}
                           data-testid="admin-password-input" />
                </div>
                {err && <div className="text-sm text-destructive" data-testid="admin-auth-error">{err}</div>}
                <button type="submit" disabled={loading}
                        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-3 font-semibold hover:bg-primary/90 disabled:opacity-60"
                        data-testid="admin-submit-btn">
                    {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                    Sign in
                </button>
            </form>
        </section>
    );
}
